export function getDefaultImage(firstName: string, lastName: string) {
  return `https://ui-avatars.com/api/?name=${firstName}+${lastName}&background=faff00&color=132132&size=128`;
}

export function getImageAlt(firstName: string, lastName: string) {
  return `${firstName} ${lastName}`;
}
